<ng-container>
  <div class="col condition-container" [ngClass]="{'highlight-row' : isAllApproved}">
    @if (!readonly) {
      <form [formGroup]="conditionForm">
        <div class="row condition-header align-top">
          <div class="col-md-1">
            <input type="number" formControlName="number" name="number" style="max-width: 75%; min-width: 75%"/>
          </div>
          <div class="col-md-2">
            <textarea
              type="text"
              formControlName="name"
              name="name"
              cdkTextareaAutosize
              [cdkAutosizeMinRows]="nameExpanded ? 3 : 1"
              [cdkAutosizeMaxRows]="nameExpanded ? 10 : 1"
              (focus)="nameExpanded = true"
              (blur)="nameExpanded = false"
            ></textarea>
          </div>
          <div class="col-md-2">
            <div class="row">
              <div class="col">
                <div style="display:flex; align-items: flex-start; max-width: 100%">
                  <div style="max-width: 95%; flex: 1">
                    <textarea
                      type="text"
                      formControlName="nickname"
                      name="nickname"
                      cdkTextareaAutosize
                      [cdkAutosizeMinRows]="nicknameExpanded ? 3 : 1"
                      [cdkAutosizeMaxRows]="nicknameExpanded ? 10 : 1"
                      (focus)="nicknameExpanded = true"
                      (blur)="nicknameExpanded = false"
                    ></textarea>
                  </div>
                  <div style="width: 18px; flex-shrink: 0; cursor: pointer; margin-left: 4px" (click)="openAdditionalNotes = !openAdditionalNotes" matTooltip="Add additional notes"><mat-icon style="font-size: 14px">{{openAdditionalNotes ? 'remove' : 'add'}}</mat-icon></div>
                </div>
              </div>
              @if (openAdditionalNotes) {
                <textarea
                  type="text"
                  style="margin-top: 3px;"
                  formControlName="additional_notes"
                  name="additional_notes"
                  cdkTextareaAutosize
                  [cdkAutosizeMinRows]="additionalNotesExpanded ? 3 : 1"
                  [cdkAutosizeMaxRows]="additionalNotesExpanded ? 10 : 1"
                  (focus)="additionalNotesExpanded = true"
                  (blur)="additionalNotesExpanded = false"
                ></textarea>
              }
            </div>
          </div>
          <div class="col-md-1">
            <select formControlName="status" style="max-width: 90%">
              @for (status of conditionsStatuses; track status) {
                <option [value]="status.id">{{status.name}}</option>
              }
            </select>
          </div>
          <div class="col-md-1">
            <input type="date" formControlName="date" name="date" style="max-width: 90%">
          </div>
          <div class="col-md-2">
            <textarea
              type="text"
              formControlName="notes"
              name="notes"
              cdkTextareaAutosize
              [cdkAutosizeMaxRows]="notesExpanded ? 10 : 1"
              [cdkAutosizeMinRows]="notesExpanded ? 3 : 1"
              (focus)="notesExpanded = true"
              (blur)="notesExpanded = false"
            ></textarea>
          </div>
          <div class="col-md-1">
            <span><input type="checkbox" name="include_in_package" formControlName="include_in_package">In Package</span>
          </div>
          <div class="col-md-2">
            <div class="row approval-button" style="justify-content: flex-end">
              <div class="col-md-1"></div>
              <div class="col-md-8">{{approvedApproval}}/ {{approvals.length}}</div>
              <!--            <div class="col-md-2"><div class="save-button" *ngIf="permissions?.conditionPermissions?._edit" (click)="updateConditionApprovals()" matTooltip="Save all conditions"><i class="material-icons">save</i></div></div>-->
              <div class="col-md-2">@if (permissions?.conditionPermissions?._delete) {
                <div class="save-button" (click)="openDeleteConditionModal()" matTooltip="Delete condition"><i class="material-icons">delete</i></div>
              }</div>
              <div class="col-md-1"><div class="dropdown-button" (click)="expandPanel()"><i class="material-icons">{{isExpanded ? 'arrow_drop_up' : 'arrow_drop_down'}}</i></div></div>
            </div>
          </div>
        </div>
      </form>
    }
    @if (readonly) {
      <div class="row condition-header">
        <div class="col-md-1">
          {{conditionForm.controls['number'].value}}
        </div>
        <div class="col-md-2">
          {{conditionForm.controls['name'].value}}
        </div>
        <div class="col-md-2">
          {{conditionForm.controls['nickname'].value}}
        </div>
        <div class="col-md-1">
          {{ readOnlyStatus }}
        </div>
        <div class="col-md-2">
          {{ conditionForm.controls['date'].value }}
        </div>
        <div class="col-md-2">
          {{ conditionForm.controls['notes'].value }}
        </div>
        <div class="col-md-2">
          <div class="row approval-button">
            <div class="col-md-1"></div>
            <div class="col-md-10">{{approvedApproval}}/{{approvals.length}}</div>
            <div class="col-md-1"><div class="dropdown-button" (click)="expandPanel()"><i class="material-icons">{{isExpanded ? 'arrow_drop_up' : 'arrow_drop_down'}}</i></div></div>
          </div>
        </div>
      </div>
    }
    @if (isExpanded) {
      <div class="row files-row">
        <div class="col-md-9 header-border">
          <div class="row file-header">
            <div class="col-md-3">
              <div class="row">
                <div class="col-md-3">
                  @if (permissions.filePermissions._create && !this.readonly) {
                    <div class="file-add-button" matTooltip="Add files from sharepoint selection" (click)="uploadFromDrive()"><i class="material-icons" style="font-size: 16px">add</i></div>
                  }
                </div>
                <div class="col-md-9">
                  File
                </div>
              </div>
            </div>
            <div class="col-md-3">
              Include in Package
            </div>
            <div class="col-md-6">
              Path
            </div>
          </div>
        </div>
        @if (isExpanded) {
          <div class="row file-content">
            <div class="col-md-9 file-content-column">
              @if (files.length > 0) {
                @for (file of files; track file) {
                  <equity-installment-file [file]="file" [readOnly]="readonly" [isInvalid]="validateErrorFiles(file)"></equity-installment-file>
                }
              }
              @if (files.length==0) {
                <div style="display: flex; justify-content: center; font-size: 12px">No Files</div>
              }
              @if (hasSite && !readonly) {
                <div class="row upload-container" [ngClass]="{'drop-area' : isDragging}" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
                  @if (!isLoading) {
                    <div [ngClass]="{'standard-display' : !isDragging, 'drop-display': isDragging}">
                      @if (!isDragging) {
                        <i class="material-icons-outlined" style="font-size: 18px; opacity: 60%; margin-right: 5px;">upload_file</i>
                      }
                      @if (isDragging) {
                        <i class="material-icons-outlined" style="font-size: 26px; opacity: 60%">file_upload</i>
                      }
                      {{isDragging ? '' : 'Upload File'}}
                      <input type="file" #fileInput (change)="browseFile($event)" style="display: none">
                      @if (!isDragging) {
                        <a href="" (click)="$event.preventDefault(); fileInput.click()" style="margin-left: 20px">Browse Files</a>
                      }
                    </div>
                  }
                  <div style="overflow: hidden; width: 45px; max-width: 45px">@if (isLoading) {
                    <mat-spinner [diameter]="20"></mat-spinner>
                  }</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (isExpanded) {
      <div class="row approval-row">
        <div class="col-md-9 header-border">
          <div class="row file-header">
            <div class="col-md-3">
              <div class="row">
                <div class="col-md-3">
                  @if (permissions.filePermissions._create && !this.readonly) {
                    <div class="file-add-button" (click)="openAddApprovalModal()" matTooltip="Add Approval"><i class="material-icons" style="font-size: 16px">add</i></div>
                  }
                </div>
                <div class="col-md-9">
                  Approver
                </div>
              </div>
            </div>
            <div class="col-md-3">
              Approved
            </div>
            <div class="col-md-2">
              User
            </div>
            <div class="col-md-4">
              <div class="row date-action">
                <div class="col-md-11">Date</div>
                <div class="col-md-1">
                  <div class="approval-history-button" (click)="openLogModal()" matTooltip="Open History Log"><i class="material-icons" style="font-size: 16px">history</i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (isExpanded) {
      <div class="row approval-content">
        @if (approvals.length>0) {
          <div class="col-md-9 approval-container">
            @for (approval of approvals; track approval) {
              <equity-installment-approval [approval]="approval" [readonly]="readonly" [statuses]="approvalStatuses"></equity-installment-approval>
            }
          </div>
        }
        @if (approvals.length==0) {
          <div class="col-md-9 approval-container">
            <ng-container>
              <div class="row" style="justify-content: center; font-size: 12px">No approvals</div>
            </ng-container>
          </div>
        }
      </div>
    }
  </div>
</ng-container>
